import React, { useEffect } from "react";
import {
  Button,
  Divider,
  Row,
  Typography,
} from "../utils/antd-imports/AntdImports";
import "./ChatCommunication.css";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeFirst } from "../utils/Utils";
import ChatAndActivitySegment from "../chat-activity-tab/ChatAndActivityTabs";
import ChatTerms from "../chat-terms/ChatTerms";
import { ReactComponent as ArrowSquare } from "../../../assests/arrow-square-out.svg";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { useNavigate } from "react-router-dom";
import { setAllowChat } from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";

const ChatCommunication = () => {
  const { Text } = Typography;

  const { isProductInfo, campaignInfoForChat, allowChat } = useSelector(
    (state) => state.chatCommunicationHandleSlice
  );
  const { userType, chatsMonitered, professionalGuidelines } = useSelector(
    (state) => state.userprofile
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sellerInfo = (
    <div>
      <Text className="chat-user-info">
        Owner: {capitalizeFirst(isProductInfo?.client_name)}
      </Text>
      <br />
      <Text className="chat-user-info">
        Product Name: {isProductInfo?.title}
      </Text>
      <br />
      <Text className="chat-user-info">
        Campaign Name: {capitalizeFirst(campaignInfoForChat?.name)}
      </Text>
    </div>
  );

  const handleProductDetails = () => {
    navigate(
      `/buyer/productsdetails?_id=${btoa(isProductInfo?.product_id)}`,
      {}
    );
    dispatch(
      addBreadcrumb({
        title: isProductInfo?.title,
        path: `/buyer/productsdetails?_id=${btoa(isProductInfo?.product_id)}`,
      })
    );
  };

  useEffect(() => {
    if (chatsMonitered === true && professionalGuidelines === true) {
      dispatch(setAllowChat(true));
    } else {
      dispatch(setAllowChat(false));
    }
  }, [chatsMonitered, professionalGuidelines, dispatch]);
  return (
    <div className="chat-communication-container">
      <div> {sellerInfo}</div>
      <Row justify="center">
        <Button
          className="view-product-btn-chatbox-modal"
          onClick={handleProductDetails}
        >
          <ArrowSquare />
          <Text className="view-product-btn-chatbox-Text">
            View Product Details
          </Text>
        </Button>
      </Row>
      <Divider />
      <div>{allowChat ? <ChatAndActivitySegment /> : <ChatTerms />}</div>
    </div>
  );
};
export default ChatCommunication;
